import { Component, Input, Inject } from '@angular/core';

import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: 'side-effect-set-DueDtAndApproveDt',
    templateUrl: './side-effect-set-DueDtAndApproveDt.component.html',
    standalone: false
})
export class SideEffectSetDueDtAndApproveDtComponent {
    public _seConfiguration: any;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};
        this._seConfiguration.isUrbanFlagLocation = this._seConfiguration.isUrbanFlagLocation || 'false';
        this._seConfiguration.isExpediteFlagLocation = this._seConfiguration.isExpediteFlagLocation || 'false';
        this._seConfiguration.applicationDueDate = this._seConfiguration.applicationDueDate || '';
        this._seConfiguration.applicationAproveAfterDate = this._seConfiguration.applicationAproveAfterDate || '';
    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.seConfiguration = data.configuration;
    }
}
